<div class="tab-pane active" role="tabpanel">
  <app-annual-performance [partner]="partner" [partnerStat]="partnerStat" [loaded]="statsLoaded"></app-annual-performance>

  <div class="row g-3">
    <div class="col-8">
      <div class="card shadow border-0 mb-3 fade-in-zoom">

        <!-- -------------- -->
        <!-- Search filters -->
        <!-- -------------- -->
        <div class="card-header fw-bold bg-tertiary p-3 border-0 d-flex justify-content-between align-items-center">
          <h2 class="fs-6 fw-bold mb-0"><i class="bi bi-rss me-2 text-primary"></i>Activity feed</h2>
          <div class="d-flex justify-content-end align-items-center gap-2">
            @if (!partner) {
              <div class="form-check form-switch mb-0 me-2 text-nowrap">
                <input [(ngModel)]="filters.values['global']" (ngModelChange)="onFilterChange()" class="form-check-input" type="checkbox" role="switch" id="globalOnly">
                <label class="form-check-label fw-normal" for="globalOnly">Global only</label>
              </div>
              <app-dropdown-select (onDropdownChange)="onFilterChange()" placeholder="Account manager" [multiple]="true" [(ngModel)]="filters.values['senderId']">
                @for (user of users; track user.id) {
                  <app-dropdown-select-option [value]="user.id">
                    {{ user }}
                  </app-dropdown-select-option>
                }
              </app-dropdown-select>
            }

            <app-dropdown-select (onDropdownChange)="onFilterChange()" placeholder="Activity" [multiple]="true" [(ngModel)]="filters.values['type']">
              <app-dropdown-select-option value="note">Notes</app-dropdown-select-option>
              <app-dropdown-select-option value="task">Tasks</app-dropdown-select-option>
              <app-dropdown-select-option value="notification">Notifications</app-dropdown-select-option>
              <app-dropdown-select-option value="login">Logins</app-dropdown-select-option>
              <app-dropdown-select-option value="signup">Signups</app-dropdown-select-option>
            </app-dropdown-select>

            @if (!partner) {
              <button (click)="openCreateModal('note')" class="btn btn-outline-primary fw-bold text-nowrap">
                <i class="bi bi-plus-lg me-2"></i>Add Note
              </button>
              <button (click)="openCreateModal('task')" class="btn btn-outline-primary fw-bold text-nowrap">
                <i class="bi bi-plus-lg me-2"></i>Add Task
              </button>
            }

            <button (click)="toggleFeedDisplay()" class="btn btn-primary fw-bold">
              @if (filters.values['feedDisplay']) {
                <i class="bi me-2 bi-eye"></i>Show
              }
              @if (!filters.values['feedDisplay']) {
                <i class="bi me-2 bi-eye-slash"></i>Hide
              }
            </button>

            @if (!partner) {
              <button type="button" class="btn btn-outline-primary" (click)="filters.saveFilters()" title="Save filters">
                <i class="bi bi-floppy"></i>
              </button>
              <button type="button" class="btn btn-outline-secondary" (click)="filters.clearFilters()" title="Clear filters">
                <i class="bi bi-eraser"></i>
              </button>
            }
          </div>
        </div>

        <!-- -------- -->
        <!-- Messages -->
        <!-- -------- -->
        <div class="card-body">
          @for (activity of activities; track activity.id; let first = $first) {
            <div (mouseenter)="readMessage(activity)" [class.mt-3]="!first" [class.global-activity]="activity.isGlobal()" class="card card-body border-0 shadow-sm">
              <div class="bg-tertiary p-2 border-start border-warning border-5 d-flex align-items-center justify-content-between mb-3">
                <span class="text-capitalize"><i [ngClass]="activity.getIconType()" class="bi text-primary me-2"></i><b>{{ activity.hasSender() ? activity.type : activity.subject }}</b>
                  @if (activity.isGlobal()) {
                    <span class="badge text-bg-info ms-2"><i class="bi bi-globe me-1"></i>Global</span>
                  }
                </span>
                <div>
                  <small class="text-muted">by {{ activity?.sender ?? 'System' }}, {{ activity.createdAt | date: "dd/MM/yy 'at' H'h'mm" }}</small>
                  <button (click)="updateFeedDisplay(activity)" class="btn btn-outline-primary btn-sm ms-2">
                    <i [class.bi-eye]="!activity.feedDisplay" [class.bi-eye-slash]="activity.feedDisplay" class="bi"></i>
                  </button>
                  @if (activity.hasSender()) {
                    <button (click)="openUpdateModal(activity)" class="btn btn-outline-primary btn-sm ms-2"><i class="bi bi-pen"></i></button>
                  }
                  <button (click)="updatePinned(activity)" [class.active]="activity.pinned" class="btn btn-outline-primary btn-sm ms-2"><i class="bi bi-pin"></i></button>
                </div>
              </div>
              @if (activity.hasSender()) {
                <p>
                  <i [ngClass]="activity.getSubjectIcon()" class="bi me-2 text-primary"></i>
                  <b>{{ activity.subject }}</b>
                  @if (!activity.messageRead) {
                    <span class="text-warning ms-3">(NOT READ)</span>
                  }
                </p>
                @if (activity.recipient) {
                  <p>
                    <b>{{ activity.isTask() ? 'Assigned' : 'Note' }} to {{ activity.recipient.id === connectedUser.id ? 'oneself' : '' }}:</b>
                    <span class="ms-2">
                      <img [ngSrc]="getImageUrl(activity.recipient)"
                        alt="Recipient profile picture"
                        class="rounded-circle avatar img-fluid me-2" width="30" height="30">{{ activity.recipient }}
                      </span>
                    </p>
                  }
                  @if (activity.partner) {
                    <p>
                      <b>Targeted affiliate:</b>
                      <span class="ms-2">
                        @if (getImageUrl(activity.partner)) {
                          <img
                            [ngSrc]="getImageUrl(activity.partner)"
                            alt="Affiliate profile picture"
                            class="rounded-circle avatar img-fluid me-2" width="30" height="30">
                        }{{ activity.partner }}
                      </span>
                    </p>
                  }
                  }
                  @if (activity.isTask()) {
                    <div class="row mb-3">
                      <div class="col-md-6">
                        <label for="dueDate" class="form-label small fw-bold">Due Date:</label>
                        <div class="input-group">
                          <input type="date" class="form-control" id="dueDate" [(ngModel)]="activity.occurringDate">
                          <input type="time" class="form-control" [(ngModel)]="activity.occurringTime">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <label for="taskStatus" class="form-label small fw-bold">Status:</label>
                        <div class="input-group">
                          <select class="form-select" id="taskStatus" [(ngModel)]="activity.status">
                            <option value="forthcoming">Forthcoming</option>
                            <option value="in_progress">In Progress</option>
                            <option value="completed">Completed</option>
                          </select>
                          <button (click)="updateActivity(activity)"
                            [disabled]="submitting"
                          type="button" class="btn btn-primary fw-bold">Validate</button>
                        </div>
                      </div>
                    </div>
                    @if (activity.repeatFrequency) {
                      <p class="text-uppercase"><b>Repetition :</b> {{ activity.repeatFrequency }}</p>
                    }
                  }
                  @if (activity.hasSender()) {
                    <p class="break-spaces"><b>Description :</b> {{ activity.message }}</p>
                  }
                  @if (!activity.hasSender()) {
                    <div [innerHTML]="activity.message"></div>
                  }
                  <!-- ------------- -->
                  <!-- OFFER REQUEST -->
                  <!-- ------------- -->
                  @if (activity.type === 'partner_offer_request') {
                    <p><b>Status :</b> {{ activity.data?.action ?? 'pending' }}</p>
                    @if (!activity.hasAction()) {
                      <div class="row">
                        <div class="col-auto">
                          <button (click)="addAction(activity, 'disabled')" [appElementLoader]="activityDataLoading"
                            appConfirm class="btn btn-danger" type="button">
                            <i class="bi bi-x-circle-fill me-2"></i>Refuse
                          </button>
                        </div>
                        <div class="col-auto">
                          <button (click)="addAction(activity, 'active')" [appElementLoader]="activityDataLoading"
                            appConfirm class="btn btn-success" type="button">
                            <i class="bi bi-check-circle-fill me-2"></i>Approve
                          </button>
                        </div>
                      </div>
                    }
                  }
                  <!-- -------------- -->
                  <!-- SIGNUP REQUEST -->
                  <!-- -------------- -->
                  @if (activity.type === 'signup') {
                    <p><b>Status :</b> {{ activity.data?.action ?? 'pending' }}</p>
                    @if (!activity.hasAction()) {
                      <div class="row">
                        <div class="col-auto">
                          <button (click)="addAction(activity, 'rejected')" [appElementLoader]="activityDataLoading"
                            appConfirm class="btn btn-danger" type="button">
                            <i class="bi bi-x-circle-fill me-2"></i>Reject
                          </button>
                        </div>
                        <div class="col-auto">
                          <button (click)="addAction(activity, 'active')" [appElementLoader]="activityDataLoading"
                            appConfirm class="btn btn-success" type="button">
                            <i class="bi bi-check-circle-fill me-2"></i>Approve
                          </button>
                        </div>
                      </div>
                    }
                  }
                  <!-- -------- -->
                  <!-- Comments -->
                  <!-- -------- -->
                  @if (activity.hasSender()) {
                    <div class="mt-3">
                      @for (comment of activity.comments; track comment.id; let i = $index) {
                        <div
                          [class.bg-white]="i%2 === 0"
                          [class.bg-light]="i%2 !== 0"
                          class="d-flex align-items-start mb-3 p-3">
                          <img [ngSrc]="getImageUrl(comment.sender)" alt="Profile picture" class="rounded-circle avatar img-fluid me-3" width="40" height="40">
                          <div>
                            <h6 class="fw-bold mb-1">{{ comment.sender }} <small class="text-muted">- {{ comment.createdAt | date: "dd/MM/yy 'at' H'h'mm" }}</small></h6>
                            <p class="mb-0">{{ comment.message }}</p>
                          </div>
                        </div>
                      }
                      <div class="d-flex align-items-center border p-3 rounded mb-3">
                        <div class="me-3">
                          <img [ngSrc]="getImageUrl(connectedUser)" alt="Avatar" width="30" height="30" class="rounded-circle avatar img-fluid">
                        </div>
                        <div class="flex-grow-1">
                          <textarea #comment class="form-control" rows="1" placeholder="Leave a comment..."></textarea>
                        </div>
                        <div class="ms-3">
                          <button (click)="submitComment(activity, comment)" type="button" class="btn btn-primary fw-bold">Comment</button>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }

              @if (paginator.currentPage < paginator.pageCount) {
                <div #observer class="mt-4 text-center text-black-50" style="font-size: 30px;">
                  <i class="spinner-border me-3"></i>Loading more...
                </div>
              }
            </div>
          </div>
        </div>

        <div class="col-4">
          <app-history-performance [partner]="partner" [partnerStat]="partnerStat" [loaded]="statsLoaded"></app-history-performance>

          @if (partner) {
            <app-block-rule-list [partner]="partner"></app-block-rule-list>
          }

          @if (partner) {
            <app-capping-rule-list [partner]="partner"></app-capping-rule-list>
          }
        </div>
      </div>
    </div>
